import 'core-js/actual';

import app from "./bootstrap-frontoffice.js";

import PortalVue from 'portal-vue'
app.use(PortalVue)

import i18n from "./i18n";
app.use(i18n)

/* Vue JS */
import Select2 from './components/frontend/ui/Select2.vue'
app.component('select2', Select2);
import Registration from './components/frontend/Registration.vue'
app.component('dtc-registration', Registration);
import BookingForm from './components/frontend/booking/BookingForm.vue'
app.component('dtc-booking-form', BookingForm);
import BookingInformation from './components/frontend/booking/BookingInformation.vue'
app.component('dtc-booking-information', BookingInformation);
import RemainingTime from './components/frontend/booking/RemainingTime.vue'
app.component('dtc-booking-remaining-time', RemainingTime);
import BookingCart from './components/frontend/booking/BookingCart.vue'
app.component('dtc-booking-cart', BookingCart);
import BookingCancellation from './components/frontend/booking/BookingCancellation.vue'
app.component('dtc-booking-cancellation', BookingCancellation);
import StoreLocator from './components/frontend/StoreLocator.vue'
app.component('dtc-store-locator', StoreLocator);
import StagesList from './components/frontend/StagesList.vue'
app.component('dtc-stages-list', StagesList);
import MapWithSingleMarker from "./components/atoms/map/MapWithSingleMarker.vue";
app.component('dtc-map-with-single-marker', MapWithSingleMarker);

import Deposit from "@/components/frontend/deposit/Deposit.vue";
app.component('dtc-deposit', Deposit);

import ProductsList from './components/frontend/ProductsList.vue'
app.component('dtc-products', ProductsList);

import ProductStageBooking from './components/frontend/booking/ProductStageBooking.vue'
app.component('dtc-products-stage-booking', ProductStageBooking)
import ProductStoreBooking from './components/frontend/booking/ProductStoreBooking.vue'
app.component('dtc-products-store-booking', ProductStoreBooking)
import ProductsSearch from './components/frontend/ProductsSearch.vue'
app.component('dtc-products-search', ProductsSearch);

import StarRating from './components/frontend/review/StarRating.vue'
app.component('star-rating', StarRating);
import ReviewModal from './components/frontend/review/ReviewModal.vue'
app.component('dtc-review-modal', ReviewModal);

import ProductSlotBookingCard from './components/frontend/booking/slot/BookingCard.vue'
app.component('dtc-product-slot-booking-card', ProductSlotBookingCard);
import ProductStoreBookingCard from './components/frontend/booking/store/BookingCard.vue'
app.component('dtc-product-store-booking-card', ProductStoreBookingCard);
import ProductDateBookingCard from './components/frontend/booking/date/BookingCard.vue'
app.component('dtc-product-date-booking-card', ProductDateBookingCard);
import AccountRegistrations from './components/frontend/registrations/AccountRegistrations.vue'
app.component('dtc-account-registrations', AccountRegistrations);
import RegistrationCard from './components/frontend/registrations/RegistrationCard.vue'
app.component('dtc-registration-card', RegistrationCard);

import AccountBooking from "@/components/frontend/booking/account/AccountBooking.vue";
app.component("dtc-account-booking", AccountBooking);


app.mount("#app");
